module.exports = "i.fa-spinner {\n    font-size: 4em;\n}\n\n.card.image-uploader {\n    border: 2px dashed #ccc;\n}\n\n.btn-light {\n    border-radius: 0;\n}\n"